import { useState } from 'react';
import { FileStatus } from './useProjectSync';

export interface ProjectRefreshOptions {
  refetchLatestVersionData?: () => Promise<void>;
  filesWithSyncRef?: React.RefObject<{
    refreshData: () => Promise<void>;
  } | null>;
  checkStatus: () => Promise<FileStatus[] | null>;
}

export const useProjectRefresh = (options: ProjectRefreshOptions) => {
  const [isRefreshing, setIsRefreshing] = useState(false);

  const { refetchLatestVersionData, filesWithSyncRef, checkStatus } = options;

  const refreshAll = async () => {
    setIsRefreshing(true);
    try {
      // Step 1: Refetch server data if available
      if (refetchLatestVersionData) {
        await refetchLatestVersionData();
      }

      // Step 2: Refresh FilesWithSync component if available
      if (filesWithSyncRef?.current) {
        await filesWithSyncRef.current.refreshData();
      }

      // Step 3: Small delay to ensure any pending file system operations complete
      await new Promise((resolve) => setTimeout(resolve, 100));

      // Step 4: Re-check local file status
      const statuses = await checkStatus();

      return statuses;
    } catch (error) {
      console.error('Error during comprehensive refresh:', error);
      throw error;
    } finally {
      setIsRefreshing(false);
    }
  };

  return {
    refreshAll,
    isRefreshing,
  };
};
